import type { ImgProps } from '@/components/atomic/atoms/layout/image/typing';
import View from '@/components/atomic/atoms/layout/view/styled';
import { BasicComponentProps } from '@/typings/generic';
import styled from '@emotion/styled';

const Img = styled(View)<ImgProps & BasicComponentProps>(
	({ $maxWidth = '100%', $width = 'auto', $height = 'auto', $objectFit }) => {
		return {
			maxWidth: $maxWidth,
			width: $width,
			height: $height,
			objectFit: $objectFit,
		};
	},
).withComponent('img');

export default Img;
